import { Notify } from "../../utils/notificationManager";
import "moment-timezone";
import moment from "moment-timezone";
export const FETCH_ZENDESK_TICKETS = "FETCH_ZENDESK_TICKETS";
export const UPDATE_ZENDESK_TICKETS = "UPDATE_ZENDESK_TICKETS";
export const FETCH_ACTIVE_ZENDESK_TICKET = "FETCH_ACTIVE_ZENDESK_TICKET";
export const UPDATE_ACTIVE_ZENDESK_TICKET = "UPDATE_ACTIVE_ZENDESK_TICKET";
export const CLEAR_ACTIVE_ZENDESK_TICKET = "CLEAR_ACTIVE_ZENDESK_TICKET";
export const CLEAR_SUPPORT_FILTER = "CLEAR_SUPPORT_FILTER";
export const UPDATE_SUPPORT_FILTER = "UPDATE_SUPPORT_FILTER";

export function fetchZendeskTickets() {
  return {
    type: FETCH_ZENDESK_TICKETS,
    meta: {
      endpoint: "/fleet/zendesk/tickets",
      success: updateZendeskTickets,
      errorMessage: "Failed to fetch Zendesk support tickets",
    },
  };
}

function updateZendeskTickets(response) {
  return {
    type: UPDATE_ZENDESK_TICKETS,
    payload: {
      zendeskTickets: formatTickets(response.data),
    },
  };
}

function formatDate(timestamp) {
  let time = moment(new Date(timestamp * 1000));
  let now = moment();
  let yesterday = moment().subtract(1, "days");
  if (time.isSame(now, "day")) {
    time = time.format("[Today] HH:mm");
  } else if (time.isSame(yesterday, "day")) {
    time = time.format("[Yesterday] HH:mm");
  } else {
    time = time.format("D MMMM HH:mm");
  }
  return time;
}

function formatTickets(tickets) {
  let ticketObj = {};
  for (let ticketId in tickets) {
    let ticket = tickets[ticketId];
    ticket["updatedAtFormatted"] = formatDate(ticket.updatedAtTimestamp);
    ticketObj[ticketId] = ticket;
  }
  return ticketObj;
}

export function fetchActiveZendeskTicket(ticketId) {
  return {
    type: FETCH_ACTIVE_ZENDESK_TICKET,
    meta: {
      endpoint: `/fleet/zendesk/ticket/comments?ticket_id=${ticketId}`,
      success: updateActiveZendeskTicket,
      errorMessage: "Failed to retrieve Zendesk support ticket",
    },
  };
}

function updateActiveZendeskTicket(response) {
  return {
    type: UPDATE_ACTIVE_ZENDESK_TICKET,
    payload: {
      ticketId: response.data.ticketId,
      ticketContents: formatActiveTicket(response.data),
    },
  };
}

function formatActiveTicket(ticket) {
  let comments = ticket.publicComments;
  let commentsSorted = comments.sort((a, b) => {
    if (a.createdAtTimestamp < b.createdAtTimestamp) return 1;
    if (a.createdAtTimestamp > b.createdAtTimestamp) return -1;
    return 0;
  });
  let commentsList = commentsSorted.map(comment => {
    comment["createdAtFormatted"] = formatDate(comment.createdAtTimestamp);
    return comment;
  });
  let activeTicket = ticket;
  activeTicket["publicComments"] = commentsList;
  activeTicket["updatedAtFormatted"] = formatDate(ticket.updatedAtTimestamp);
  return activeTicket;
}

export function createZendeskTicket(ticket) {
  return {
    type: "NO-OP",
    meta: {
      endpoint: "/fleet/zendesk/ticket/create",
      method: "POST",
      body: {
        subject: ticket.subject,
        address: ticket.address,
        comment: ticket.comment,
      },
      success: updateCreateTicket,
    },
  };
}

export function clearActiveZendeskTicket() {
  return {
    type: CLEAR_ACTIVE_ZENDESK_TICKET,
  };
}

export function submitZendeskComment(comment, ticket_id) {
  return {
    type: "NO-OP",
    meta: {
      endpoint: "/fleet/zendesk/ticket/comment",
      method: "POST",
      body: {
        ticket_id: ticket_id.toString(),
        comment: comment,
      },
      success: updateActiveZendeskTicket,
    },
  };
}

export function updateSupportFilter(filterKey, filterValue) {
  return {
    type: UPDATE_SUPPORT_FILTER,
    payload: {
      filterKey: filterKey,
      filterValue: filterValue,
    },
  };
}

export function clearSupportFilter() {
  return {
    type: CLEAR_SUPPORT_FILTER,
  };
}

function updateCreateTicket(response) {
  if (response.status === "OK") {
    Notify.success("Ticket Created", `#${response.data.id} - ${response.data.subject}`);
  }
}
